import React from "react";
import { LinkPreview } from "@dhaiwat10/react-link-preview";

const LinkWithPreview = ({ url, preview }) => {
  return (
    <>
      {preview && (
        <a
          className="text-decoration-none"
          rel="noopener noreferrer"
          href={url}
          target="_blank"
        >
          <div style={{ marginBottom: 8 }}>
            <LinkPreview
              url={url}
              width="100%"
              height="auto"
              showLoader={false}
              borderRadius="8px"
              fallback={
                <div
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    backgroundColor: "#f5f5f5",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div
                      className="text-dark"
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {new URL(url).hostname}
                    </div>
                    <div style={{ fontSize: "12px", color: "#888" }}>
                      Click to open link
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        </a>
      )}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1890ff", textDecoration: "underline" }}
      >
        {url}
      </a>
    </>
  );
};

export const renderTextWithLinks = (text, preview = true) => {
  if (!text) return <span></span>;

  // URL regex pattern
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Check if the message is just a URL (with potential whitespace)
  const trimmedText = text.trim();
  if (trimmedText.match(new RegExp(`^${urlRegex.source}$`))) {
    // If it's just a URL, show the clickable URL + preview
    return (
      <div
        style={{
          width: "100%",
          wordWrap: "break-word",
          wordBreak: "break-all", // Break long URLs
        }}
      >
        <LinkWithPreview url={trimmedText} preview={preview} />
      </div>
    );
  }

  // For messages with no URLs, just return the text
  if (!text.match(urlRegex)) {
    return (
      <span
        style={{
          wordWrap: "break-word",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap", // Preserve line breaks
        }}
      >
        {text}
      </span>
    );
  }

  // For messages with mixed content (text + URLs)
  const elements = [];
  let lastIndex = 0;
  let match;

  // Create a new regex object to process URLs
  const regex = new RegExp(urlRegex);

  while ((match = regex.exec(text)) !== null) {
    // Add text before the URL
    if (match.index > lastIndex) {
      elements.push(
        <span key={`text-${lastIndex}`}>
          {text.substring(lastIndex, match.index)}
        </span>
      );
    }

    // Add the URL as a link with preview
    elements.push(
      <React.Fragment key={`link-${match.index}`}>
        <LinkWithPreview url={match[0]} />
      </React.Fragment>
    );

    lastIndex = match.index + match[0].length;
  }

  // Add any remaining text after the last URL
  if (lastIndex < text.length) {
    elements.push(<span key="text-end">{text.substring(lastIndex)}</span>);
  }

  return <>{elements}</>;
};
